"use client";

import type { FilterSearchParams } from "@entities/resources/ui/filter-bar";
import { resourceTypes } from "@entities/resources/ui/filter-bar/config";
import { Input } from "@entities/resources/ui/filter-bar/input";
import { Select } from "@entities/resources/ui/filter-bar/select";
import { useDebounce } from "@uidotdev/usehooks";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export type FilterBarProps = { searchParams: FilterSearchParams };

export function FilterBar({ searchParams }: FilterBarProps) {
  const router = useRouter();

  const [searchTerm, setSearchTerm] = useState(searchParams["search"] ?? "");
  const [resourceType, setResourceType] = useState(searchParams["type"] ?? "");

  const debouncedSearchTime = useDebounce(searchTerm, 300);

  useEffect(
    () =>
      router.replace(
        `/resources?search=${debouncedSearchTime}&type=${resourceType}`
      ),
    [debouncedSearchTime, resourceType, router]
  );

  return (
    <div
      className={
        "w-full flex flex-col lg:flex-row gap-4 justify-between lg:mt-16 pb-8 border-b border-gray-100"
      }
    >
      <Input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <Select
        options={resourceTypes}
        value={resourceType}
        onChange={(e) => setResourceType(e.target.value)}
      />
    </div>
  );
}
